import React from "react";
import ContactFormClicks from "./contact-form-clicks";
import ContactMap from "./contact-map";
import { CONTACT_PAGE } from "./contact-page-data";

export default function ContactPageLayout({ locale = "en", form }) {
	const copy = CONTACT_PAGE[locale] || CONTACT_PAGE.en;

	return (
		<section className="tu-contact" aria-labelledby="tu-contact-heading">
			<div className="tu-container">
				<header className="tu-contact__header">
					<h1 id="tu-contact-heading" className="tu-contact__title">
						{copy.title}
					</h1>
					{copy.intro ? (
						<p className="tu-contact__intro">{copy.intro}</p>
					) : null}
				</header>

				<div className="tu-contact__map">
					<ContactMap
						title={copy.mapTitle}
						src={copy.mapSrc}
						openUrl={copy.mapOpenUrl}
						loadLabel={copy.mapLoadLabel}
						openLabel={copy.mapOpenLabel}
					/>
				</div>

				<div className="tu-contact__grid">
					<div className="tu-contact__main">{form}</div>
					<ContactFormClicks localeCopy={copy.clicks} />
				</div>
			</div>
		</section>
	);
}
